import React from "react";
import { useVoiceTimer } from "../contexts/VoiceTimerContext";
import Leaderboard from "../components/Analytics/Leaderboard";
import PerformanceDashboard from "../components/Analytics/PerformanceDashboard";
import { getStaffTargets } from "../utils/staff";

const STEP_LABEL = { throw: "Throwing", trim: "Trimming", attach_handle: "Attach Handle", glaze: "Glazing" };
const stepLabel = (k) => STEP_LABEL[k] || (k?.charAt(0).toUpperCase() + k?.slice(1));

export default function StudioAnalytics() {
  const { logs } = useVoiceTimer();
  const { totalTarget, totalMinutes, pct } = studioProgress(logs);

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-xl font-semibold">Studio Analytics</h1>
      <div className="rounded-2xl border p-4 flex items-center gap-4">
        <ProgressRing pct={pct}/>
        <div>
          <div className="font-semibold">Studio Weekly Progress</div>
          <div className="text-sm opacity-70">{totalTarget ? `${Math.round(totalMinutes)} / ${totalTarget} min` : "No studio target set"}</div>
          {pct != null && <div className="text-xs opacity-50">{Math.round((pct||0)*100)}% of goal</div>}
        </div>
      </div>
      <Leaderboard logs={logs} />
      <PerformanceDashboard logs={logs} stepLabel={stepLabel} />
    </div>
  );
}
function studioProgress(logs){const targets=getStaffTargets();const totalTarget=Object.values(targets).reduce((a,v)=>a+Number(v||0),0);const now=new Date();const ws=startOfWeek(now);const we=endOfWeek(now);const inRange=(d,s,e)=>d>=s&&d<=e;const totalMinutes=(logs||[]).reduce((sum,L)=>{const dt=new Date(L.finishedAt||L.startedAt);return inRange(dt,ws,we)?sum+(Number(L.minutes)||0):sum;},0);return{totalTarget,totalMinutes,pct:totalTarget>0?totalMinutes/totalTarget:null};}
function ProgressRing({ pct }){const clamped=Math.max(0,Math.min(1,pct||0));const radius=36,stroke=6,circ=2*Math.PI*radius,offset=circ*(1-clamped);return(<svg width="90" height="90" className="rotate-[-90deg]"><circle r={radius} cx="45" cy="45" stroke="#e5e7eb" strokeWidth={stroke} fill="transparent"/><circle r={radius} cx="45" cy="45" stroke="#10b981" strokeWidth={stroke} fill="transparent" strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"/></svg>);}
function startOfWeek(date,weekStartsOn=1){const d=new Date(date);const day=(d.getDay()+7-weekStartsOn)%7;d.setHours(0,0,0,0);d.setDate(d.getDate()-day);return d;}
function endOfWeek(date,weekStartsOn=1){const s=startOfWeek(date,weekStartsOn);const e=new Date(s);e.setDate(e.getDate()+6);e.setHours(23,59,59,999);return e;}
